@if (!dialogData) {
  <app-menu-common url="sales"></app-menu-common>
  <div class="pageheader flexcolumn">
    <section class="flexrow">
      <div class="grey pagetitle">Périodes fiscales</div>
    </section>
  </div>
}

@if (dialogData) {
  <div class="flexrow">
    <h2 mat-dialog-title>Périodes</h2>
    <span class="spacer"></span>
    <button class="closebutton" [mat-dialog-close]=""><mat-icon>close</mat-icon></button>
  </div>
}

<mat-dialog-content>
  <div class="pagecontent">
    @if (dataOk) {
      <!-- Commissioning Form -->
      @if (isCommissioning) {
        <div class="commissioning-container flexcolumn"
          style="gap: 15px; padding: 20px; align-items: center; text-align: center;">
          <mat-icon color="primary" style="transform: scale(2); margin-bottom: 15px;">input</mat-icon>
          <h2>{{ commissioningMsg }}</h2>
          <p class="grey-text" style="max-width: 400px; margin-bottom: 20px;">
            @if (hasDrawer) {
              Cette station de caisse n'a pas encore été mise en service. Veuillez déclarer le montant du fond de caisse
              initial pour initialiser le système fiscal.
            } @else {
              Ce poste n'a pas encore été mis en service.
            }
          </p>
          <div class="flexcolumn" style="gap: 10px; width: 100%; max-width: 300px;">
            @if (hasDrawer) {
              <mat-form-field appearance="outline" style="width: 100%;">
                <mat-label>Fond de caisse initial</mat-label>
                <input matInput appCents type="number" [formControl]="cashInControl" placeholder="Ex: 150" (focus)="$any($event.target).select()">
                <span matTextSuffix>&nbsp;€</span>
                <button mat-icon-button matIconSuffix type="button" (click)="onCountEnrollFloat()" id="enroll_count" aria-label="Compter pièces et billets" title="Compter pièces et billets"><mat-icon>calculate</mat-icon></button>
                <mat-error>Montant ≥ 0, deux décimales au plus, sous 1 000 000 000 €</mat-error>
              </mat-form-field>
              @if (enrollDiffersFromCount) {
                <div class="enroll-differs" id="enroll-differs">Saisi à la main : différent du comptage ({{ enrollCountTotal | currency:'EUR':'symbol':'1.2-2':'fr-FR' }})</div>
              }
            }
            <button mat-flat-button color="primary" id="enroll_button" style="height: 48px; font-weight: 500;"
              [disabled]="hasDrawer && (cashInControl.value === null || cashInControl.invalid)" (click)="onEnrollStation()">
              Valider la mise en service
            </button>
          </div>
        </div>
      }
      @if (!isCommissioning) {
        <section class="period-row">
          <div class="label">Exercice Annuel</div>
          @if (yearPeriod) {
            <div class="details">
              <span class="date">{{ yearPeriod.getRangeString() }}</span>
              <span class="total">Cumul: {{ yearPeriod.grand_total_ttc | currency:'EUR':'symbol':'1.2-2':'fr-FR' }}</span>
            </div>
          }
          @if (yearPeriod) {
            <button mat-flat-button color="warn" (click)="onClosePeriod(0)">Clôturer l'année</button>
          }
          @if (!yearPeriod) {
            <button mat-flat-button color="primary" (click)="onOpenPeriod(0)">Initialiser
            l'année</button>
          }
        </section>
        <hr>
          <section class="period-row">
            <div class="label">Mois Fiscal</div>
            @if (monthPeriod) {
              <div class="details">
                <span class="date">{{ monthPeriod.getRangeString() }}</span>
                <span class="total">Période: {{ monthPeriod.total_ttc | currency:'EUR':'symbol':'1.2-2':'fr-FR' }}</span>
              </div>
            }
            @if (monthPeriod) {
              <button mat-flat-button color="warn" (click)="onClosePeriod(1)">Clôturer le mois</button>
            }
            @if (!monthPeriod) {
              <button mat-flat-button color="primary" (click)="onOpenPeriod(1)">Ouvrir le mois</button>
            }
          </section>
          <hr>
            @if (dayPeriod) {
              <section class="period-row">
                <div class="label">Session Journalière</div>
                <div class="details">
                  <span class="date" [class.warn-text]="isHardExpired">
                    {{ dayPeriod.getRangeString() }}
                    @if (isSoftExpired) {
                      <small style="color: #f57c00; font-weight: 500;"> (Session à clôturer — {{ softLimitNote }})</small>
                    }
                    @if (isHardExpired) {
                      <small class="warn-text" style="font-weight: 500;"> ({{ hardLimitLabel }} dépassée !)</small>
                    }
                  </span>
                  <span class="total">Ventes: {{ dayPeriod.total_ttc | currency:'EUR':'symbol':'1.2-2':'fr-FR' }}</span>
                  @if (expectedCash !== null) {
                    <span class="total expected-cash" id="expected_cash" [class.neg]="expectedCash < 0">Espèces attendues : {{ expectedCash | currency:'EUR':'symbol':'1.2-2':'fr-FR' }}</span>
                  }
                </div>
                <div class="row-actions">
                  <button mat-stroked-button type="button" id="session_recap_button" (click)="onShowRecap()">Récapitulatif</button>
                  @if (dayPeriod.status == 'open') {
                    <button mat-flat-button color="warn" (click)="onClosePeriod(2)">
                      {{ hasDrawer ? 'Fermer la caisse (Z)' : 'Clôturer la journée (Z)' }}
                    </button>
                  }
                  @if (dayPeriod.status == 'closed') {
                    <button mat-flat-button color="primary" (click)="onOpenPeriod(2)">
                      Nouvelle session
                    </button>
                  }
                </div>
              </section>
            } @else {
              <section class="period-row">
                <div class="label">Session Journalière</div>
                <div class="details grey">Aucune session active</div>
                <button mat-flat-button color="primary" (click)="onOpenPeriod(2)">Démarrer la journée</button>
              </section>
            }
          }
        }

        @if (!dataOk && !dataError && (serverStatusService.isOnline$ | async)) {
          <div class="loading-state">
            <p>Synchronisation fiscale...</p>
          </div>
        }
        @if (dataError) {
          <div class="error-state">
            <mat-icon color="warn">error</mat-icon>
            <p>Erreur d'intégrité de la chaîne fiscale. Contactez le support.</p>
          </div>
        }
        <app-offline-banner></app-offline-banner>
      </div>
    </mat-dialog-content>

    @if (dialogData) {
      <mat-dialog-actions align="end">
        <button mat-stroked-button mat-dialog-close>Fermer</button>
      </mat-dialog-actions>
    }